<template>
  <div id="app" v-show="lang">
    <Header />
    <!-- <Slide1 /> -->
    <Slides />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Slides from "./components/Slides";

import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Slides,
  },
  computed: {
    ...mapState(["lang"]),
  },
};
</script>

<style lang='scss' scoped>
@import "~@assets/styles/util.scss";

::v-deep .pc-header {
  background-color: rgba(0, 0, 0, 0.4);
}

.wrap {
  @extend .iphoneX;
}
</style>
